import axios, {AxiosInstance} from 'axios';
import {getToken} from "./auth";
import config from "../config";

class Api {
    axios: AxiosInstance;

    constructor() {
        this.axios = axios.create({
            baseURL: config.apiUrl,
            headers: {
                'ContentType': 'application/json'
            }
        });

        this.axios.interceptors.request.use(async (requestConfig) => {
            let token = getToken();
            if (token) requestConfig.headers.Authorization = 'Bearer ' + token;

            requestConfig.headers['X-SCHOOL-TOKEN'] = config.schoolToken;

            return requestConfig;
        });
    }

    login(email, password) {
        return this.axios.post('/oauth/token', {
            grant_type: "password",
            client_id: config.clientId,
            username: email,
            password,
            scope: "student"
        });
    }

    register(data) {
        return this.axios.post('/student/register', data);
    }

    fetchMe() {
        return this.axios.get('/student/me');
    }

    fetchAvailablePlans() {
        return this.axios.get('/student/available-plans');
    }

    fetchRecentCoverages() {
        return this.axios.get('/student/recent-coverages');
    }

    fetchActiveCoverages() {
        return this.axios.get(`/student/active-coverages`);
    }

    enroll(values) {
        return this.axios.post('/student/enroll', values);
    }

    upgrade(values) {
        return this.axios.post('/student/upgrade', values);
    }

    editProfile(values) {
        return this.axios.patch('/student/profile', values);
    }

    fetchCustomFields() {
        return this.axios.get(`/student/custom-fields`);
    }

    fetchSchool() {
        return this.axios.get(`/student/school/${config.schoolToken}`);
    }

    forgetPassword(email, verification_code) {
        return this.axios.post('/password/forget', { email, verification_code });
    }

    resetPassword(values) {
        return this.axios.post('/password/reset', values)
    }

    saveCoverageDependents(coverageId, values) {
        return this.axios.post(`/student/coverages/${coverageId}/dependents`, values);
    }

    fetchActiveEnrollmentPeriod() {
        return this.axios.get(`/student/active-enrollment-period`);
    }

    fetchLookups(requested) {
        return this.axios.get(`/lookups`, {params: {requested}});
    }
}

export default new Api();
